import { render, staticRenderFns } from "./accountsAccessBlock.vue?vue&type=template&id=52c2774c&scoped=true&"
import script from "./accountsAccessBlock.vue?vue&type=script&lang=js&"
export * from "./accountsAccessBlock.vue?vue&type=script&lang=js&"
import style0 from "./accountsAccessBlock.vue?vue&type=style&index=0&id=52c2774c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c2774c",
  null
  
)

export default component.exports